import React from "react";
import { Box, Typography } from "@mui/material";
import CompanyLogo from "./CompanyLogo";

interface TitleProps {
  name: string | undefined;
}

const Title = ({ name }: TitleProps) => {
  return (
    <Box sx={{display: "flex"}}>
      <CompanyLogo src=""/>
      <Box className="ml-4">
        <Typography fontSize={18} fontWeight={500} className="text-18-medium" style={{ color: "#333" }}>
          {name}
        </Typography>
      </Box>
    </Box>
  );
};
export default Title;
